module.exports = {"id":"239088","name":"Rafael Perez","rating":"73","photo":"./data/images/photos/4/239088.png","club":{"name":"Junior","logo":"./data/images/clubs/Junior.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RafaelPerez0.json
// module id = 3511
// module chunks = 0